
import { defineComponent } from "vue";

import PiarContent from "./components/PiarContent.vue";

export default defineComponent({
    name: "PiarContentPage",
    components: {
        PiarContent
    },
});
